'use strict';

var crypto = typeof window === 'object' && (window.crypto || window.msCrypto); // IE 11 uses window.msCrypto

function randomByte() {
    if (!crypto || !crypto.getRandomValues) {
        return Math.floor(Math.random() * 256) & 0x30;
    }
    var dest = new Uint8Array(1);
    crypto.getRandomValues(dest);
    return dest[0] & 0x30;
}

module.exports = randomByte;



/*****************
 ** WEBPACK FOOTER
 ** ./~/shortid/lib/random/random-byte-browser.js
 ** module id = 4101
 ** module chunks = 0
 **/